import { renderless, api } from "@opentiny/vue-renderless/carousel/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { IconChevronLeft, IconChevronRight, IconChevronUp, IconChevronDown } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  props: [].concat(props, ["initialIndex", "height", "trigger", "autoplay", "interval", "indicatorPosition", "indicatorStyle", "arrow", "type", "showTitle", "loop", "aspectRatio"]),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  },
  components: {
    IconChevronLeft: IconChevronLeft(),
    IconChevronRight: IconChevronRight(),
    IconChevronUp: IconChevronUp(),
    IconChevronDown: IconChevronDown()
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "relative overflow-hidden rounded",
    on: {
      "mouseenter": function mouseenter($event) {
        $event.stopPropagation();
        return _vm.handleMouseEnter.apply(null, arguments);
      },
      "mouseleave": function mouseleave($event) {
        $event.stopPropagation();
        return _vm.handleMouseLeave.apply(null, arguments);
      }
    }
  }, [_c("div", {
    ref: "carousel",
    staticClass: "relative overflow-hidden rounded",
    style: _vm.state.style,
    on: {
      "touchstart": _vm.touchstart,
      "touchmove": _vm.touchmove,
      "touchend": _vm.touchend
    }
  }, [_vm.arrow !== "never" ? _c("button", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrow === "always" || _vm.state.hover) && (_vm.loop || _vm.state.activeIndex > 0),
      expression: "(arrow === 'always' || state.hover) && (loop || state.activeIndex > 0)"
    }],
    staticClass: "absolute group border-none outline-0 p-0 m-0 h-8 w-8 cursor-pointer z-[3] rounded-full bg-color-bg-3 active:bg-color-bg-3 text-color-text-inverse text-center text-xs flex items-center justify-center hover:bg-color-text-primary",
    class: [_vm.type === "vertical" ? "top-4 left-1/2" : "left-4 top-1/2 -translate-y-4"],
    attrs: {
      "type": "button"
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.handleButtonEnter("left");
      },
      "mouseleave": _vm.handleButtonLeave,
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.throttledArrowClick(_vm.state.activeIndex - 1);
      }
    }
  }, [_c(_vm.type === "vertical" ? "icon-chevron-up" : "icon-chevron-left", {
    tag: "component",
    staticClass: "w-4.5 h-4.5 opacity-50 fill-color-bg-2 group-active:fill-color-bg-2 group-hover:fill-color-bg-1"
  })], 1) : _vm._e(), _vm.arrow !== "never" && _vm.state.items.length > 1 ? _c("button", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrow === "always" || _vm.state.hover) && (_vm.loop || _vm.state.activeIndex < _vm.state.items.length - 1),
      expression: "(arrow === 'always' || state.hover) && (loop || state.activeIndex < state.items.length - 1)"
    }],
    staticClass: "absolute group border-none outline-0 p-0 m-0 h-8 w-8 cursor-pointer z-[3] rounded-full bg-color-bg-3 active:bg-color-bg-3 text-color-text-inverse text-center text-xs flex items-center justify-center hover:bg-color-text-primary",
    class: [_vm.type === "vertical" ? "top-auto left-1/2 bottom-4" : "right-4 top-1/2 -translate-y-4"],
    attrs: {
      "type": "button"
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.handleButtonEnter("right");
      },
      "mouseleave": _vm.handleButtonLeave,
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.throttledArrowClick(_vm.state.activeIndex + 1);
      }
    }
  }, [_c(_vm.type === "vertical" ? "icon-chevron-down" : "icon-chevron-right", {
    tag: "component",
    staticClass: "w-4.5 h-4.5 opacity-50 fill-color-bg-2 group-active:fill-color-bg-2 group-hover:fill-color-bg-1"
  })], 1) : _vm._e(), _vm._t("default")], 2), _vm.indicatorPosition !== "none" && _vm.state.items.length > 1 ? _c("ul", {
    class: ["list-none m-0 py-0 px-1 z-[2] flex justify-center items-center", _vm.type === "vertical" && _vm.indicatorPosition !== "outside" ? "flex-col left-4 bottom-0 transform-none w-1 h-full py-1 px-0" : "w-full h-1 left-0 bottom-4", _vm.indicatorPosition === "outside" ? "static mt-2" : "absolute", _vm.state.hasLabel ? "left-0 right-0 text-center transform-none" : "", _vm.showTitle ? "left-auto right-3 bottom-[0.1875rem] transform-none bg-transparent" : ""]
  }, _vm._l(_vm.state.items, function(item, index) {
    return _c("li", {
      key: index,
      class: ["group cursor-pointer", _vm.type === "vertical" ? "block h-auto my-1 mx-0 p-0 first:pl-0 last:pr-0" : "inline-block h-1 p-0 my-0 mx-1", _vm.state.hasLabel ? "py-1.5 px-1" : ""],
      on: {
        "mouseenter": function mouseenter($event) {
          return _vm.throttledIndicatorHover(index);
        },
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleIndicatorClick(index);
        }
      }
    }, [_c("button", {
      class: _vm.m(["block border-none outline-0 p-0 m-0 cursor-pointer rounded-sm", _vm.indicatorPosition === "outside" || _vm.indicatorStyle === "dark" ? "bg-color-bg-3 hover:bg-color-text-disabled" : "bg-color-bg-6 hover:bg-color-bg-5", _vm.state.hasLabel ? "py-0.5 px-4.5 text-xs" : "", _vm.type === "vertical" ? "h-2 w-[0.1875rem]" : "w-2 h-[0.1875rem]", index === _vm.state.activeIndex ? _vm.indicatorPosition === "outside" || _vm.indicatorStyle === "dark" ? "bg-color-text-primary" : "bg-color-bg-1" : ""]),
      attrs: {
        "type": "button"
      }
    }, [_vm.state.hasLabel ? _c("span", [_vm._v(_vm._s(item.label))]) : _vm._e()])]);
  }), 0) : _vm._e()]);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
